import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';
import Airport from './../models/Airport';

const initialState = {
    isFetching: false,
    isFetched: false,
    airports: [],
    airlineDomestic: [],
    airportDeparture: [],
    airportArrival: [],
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    detail: {
        airport: new Airport()
    },
    toAirportList: [],
    airlineSourceVJ:""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.AIRPORT_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.AIRPORT_LIST_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                airports: action.airports.result,
                pageSize: action.airports.pageSize,
                pageIndex: action.airports.pageIndex,
                totalCount: action.airports.totalCount,
                totalPage: Math.ceil(parseInt(action.totalCount) / parseInt(action.pageSize))
            };
        case Types.AIRPORT_LIST_FAIL:
            return { ...state, isFetching: false, isFetched: true, airports: [] };
        case Types.AIRLINE_LIST_DOMESTIC_ACTION:
            return { ...state, isFetching: true };
        case Types.AIRLINE_LIST_DOMESTIC_SUCCESS:
            return {
                ...state,
                isFetching: false,
                airlineDomestic: action.airlines,
            };
        case Types.AIRLINE_LIST_DOMESTIC_FAIL:
            return { ...state, isFetching: false, airportDomestic: [] };
        case Types.AIRPORT_LIST_DEPARTURE_ACTION: 
            return {
                ...state,
                isFetching: true
            }
        case Types.AIRPORT_LIST_DEPARTURE_SUCCESS:
            return {
                ...state,
                isFetching: false,
                airportDeparture: action.airportsDeparture
            }
        case Types.AIRPORT_LIST_DEPARTURE_FAIL:
            return {
                ...state,
                isFetching: false,
                airportDeparture: []
            }
        case Types.AIRPORT_LIST_ARRIVAL_ACTION:
            return {
                ...state,
                isFetching: true
            }
        case Types.AIRPORT_LIST_ARRIVAL_SUCCESS:
            return {
                ...state,
                isFetching: false,
                airportArrival: action.airportsArrival
            }
        case Types.AIRPORT_LIST_ARRIVAL_FAIL:
            return {
                ...state,
                isFetching: false,
                airportArrival: []
            }
        case Types.AIRPORT_DETAIL_ACTION:
            return { ...state, isFetching: true, detail: initialState.detail };
        case Types.AIRPORT_DETAIL_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                detail: {
                    airport: action.airport
                }
            };
        case Types.AIRPORT_DETAIL_FAIL:
            return { ...state, isFetching: false, isFetched: true };
        case Types.AIRPORT_DETAIL_CREATE_ACTION:
            return { ...state, isFetching: true };
        case Types.AIRPORT_DETAIL_DELETE_ACTION:
            return { ...state, isFetching: true };
        // case Types.AIRPORT_DETAIL_UPDATE_ACTION:
        //     return { ...state, isFetching: true };
        // case Types.AIRPORT_CREATE_TRANSLATE_ACTION:
        //     return { ...state, isFetchingUpdate: true };
        // case Types.AIRPORT_CREATE_TRANSLATE_SUCCESS:
        //     return { ...state, isFetchingUpdate: false };
        // case Types.AIRPORT_DELETE_TRANSLATE_ACTION:
        //     return { ...state, isFetchingUpdate: true };
        // case Types.AIRPORT_DELETE_TRANSLATE_SUCCESS:
        //     return { ...state, isFetchingUpdate: false };
        // case Types.AIRPORT_UPDATE_TRANSLATE_ACTION:
        //     return { ...state, isFetchingUpdate: true };
        // case Types.AIRPORT_UPDATE_TRANSLATE_SUCCESS:
        //     return { ...state, isFetchingUpdate: false };
        // case Types.AIRPORT_FAIL:
        //     return { ...state, isFetching: false, isFetchingUpdate: false, isFetched: true };
        case Types.TOAIRPORT_LIST_ACTION:
            return { ...state, isFetching: true, toAirportList: initialState.toAirportList };
        case Types.TOAIRPORT_LIST_FAIL:
            return { ...state, isFetching: false };
        case Types.TOAIRPORT_LIST_SUCCESS:
            return {
                ...state,
                isFetching: false,
                toAirportList: action.airports
            };
        case Types.AIRLINE_SOURCE_GET:
            return {
                ...state,
                isFetching: true,
            }
        case Types.AIRLINE_SOURCE_SET:
        return {
            ...state,
            isFetching: false,
            airlineSourceVJ: action.airlineSourceVJ
        }
        case Types.AIRLINE_SOURCE_UPDATE_SUCCESS:
        return {
            ...state,
            isFetching: false,
            airlineSourceVJ: action.airlineSourceVJ
        }
        case Types.AIRLINE_SOURCE_UPDATE:
        return {
            ...state,
            isFetching: true,
        }
        default: 
            return state
    }
}
